<template>
	<transition name="fade" :duration="{ enter: 500, leave: 1000 }">
		<div class="initial-loader" v-if="isDisplayed">
			<img class="akkodis-rectangle" src="@/common/assets/icons/akkodis-blue-square.svg">
			<img class="akkodis-letter" src="@/common/assets/icons/akkodis-logo-letter.svg">
			<img class="drc-text" src="@/common/assets/icons/drc-text.svg">
		</div>
	</transition>
</template>
<script>

export default {
	name: "InitialAnimation",
	data() {
		return {
			isDisplayed: true
		};
	},
	methods: {},
	created() {
		setTimeout(() => {
			this.isDisplayed = false;
		}, 3000);
	},
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.fade-enter-active,
.fade-leave-active {
	opacity: 1;
	transition: all 1s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.initial-loader {
	position: absolute;
	z-index: 101;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	animation: mainLoader 3s ease-out normal;
	overflow: hidden;

	.akkodis-rectangle {
		text-align: center;
		animation: initialRectangle 3s ease-out normal;
		position: absolute;
		transform: scale(1);
		margin-top: 10vh;
		margin-right: 80vw;
		opacity: 0;
		overflow: hidden;
	}

	.akkodis-letter {
		position: absolute;
		animation: initialLetter 3s ease-out normal;
		transform: scale(1);
		margin-top: 10vh;
		margin-right: 80vw;
		opacity: 0;
		overflow: hidden;
	}

	.drc-text {
		color: $newsletter-hover-background;
		position: absolute;
		animation: initialText 3s ease-out normal;
		z-index: -1;
		margin-top: 400px;
		margin-right: 20vw;
		opacity: 0;
		overflow: hidden;
	}

	@keyframes mainLoader {
		0% {
			transform: scale(1.5);
		}
		35% {
			transform: scale(1.5);
		}
		50% {
			transform: scale(1);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes initialText {
		0% {
			margin-top: 200px;
			margin-right: 0;
			opacity: 1;
		}
		70% {
			margin-top: 200px;
			margin-right: 0;
			opacity: 1;
		}
		100% {
			margin-top: 400px;
			margin-right: 20vw;
			opacity: 0;
		}
	}

	@keyframes initialLetter {
		0% {
			transform: scale(1);
			margin-top: -400vh;
			margin-right: 400vw;
			opacity: 0;
		}
		27% {
			margin-top: -16vh;
			margin-right: 16vw;
			opacity: 0;
		}
		30% {
			margin-top: 0;
			margin-right: 0;
			opacity: 1;
		}
		70% {
			margin-top: 0;
			margin-right: 0;
			opacity: 1;
			transform: scale(1);
		}
		100% {
			margin-top: 10vh;
			margin-right: 80vw;
			opacity: 0;
			transform: scale(1.5);
		}
	}

	@keyframes initialRectangle {
		0% {
			transform: scale(50);
			margin-top: 0;
			margin-right: 0;
			opacity: 1;
		}
		30% {
			transform: scale(1);
			margin-top: 0;
			margin-right: 0;
			opacity: 1;
		}
		70% {
			transform: scale(1);
			margin-top: 0;
			margin-right: 0;
			opacity: 1;
		}
		100% {
			transform: scale(1.5);
			margin-top: 10vh;
			margin-right: 80vw;
			opacity: 0;
		}
	}

}
</style>
